import React from 'react';
import Header from '../Header/Header';
import { Row, Col } from 'react-bootstrap';
import t from '../../Components/Translations/lang.json';

const Success = () => {
    var url = new URL(window.location);
    var lang = url.searchParams.get('language')
        ? url.searchParams.get('language')
        : 'de';
    const currentLang = lang;
    return (
        <>
            <Header question={t[currentLang].success} />
            <Row className='mt-5 pt-5 justify-content-center text-center'>
                <Col xs={8}>
                    <h2>
                        {t[currentLang].thanks}
                    </h2>
                </Col>
            </Row>
        </>
    );
};

export default Success;
<Header />;
